import { useIntl } from "react-intl";
import { Field } from "react-final-form";
import Section from "../../common/section";
import { MultiSelectInput } from "../../common/fields";
import { GlobalConstants } from "../../../constants";

const LanguageConfigurationForm = ({ disabled }) => {
  const intl = useIntl();
  return (
    <div className="flex flex-column gap-2">
      <Section title="language_settings">
        <div className="grid">
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              component={MultiSelectInput}
              name="allowedLanguages"
              label={intl.formatMessage({
                id: "allowed_languages",
              })}
              filter={true}
              options={GlobalConstants.LANGUAGES.map((language) => ({
                ...language,
                id: language.code,
                name: language.name,
              }))}
              disabled={disabled}
            />
          </div>
        </div>
      </Section>
    </div>
  );
};

export default LanguageConfigurationForm;
